/* esm.sh - d3-transition@3.0.1/src/transition/on */
export * from "/*d3-transition@3.0.1/esnext/src/transition/on.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/on.mjs";
